import * as HELPER from "../../../src/config/helper";
import { useLanguage } from "../../../src/context/LanguageContext";
import { useState,useEffect } from "react";
import {REMITTANCE_TYPE} from '../../config/constant'
import { useParams } from "react-router-dom";

const OtoRevenueCard = (props: any) => {
  const { id,type } = useParams<{ id: string,type:string }>()
  const {revenue,remittanceDetails} = props
  const { translations } = useLanguage();
  const [bipd , setBipd] = useState(null);

  useEffect(() => {
      if (Array.isArray(props.remittanceDetails) && props.remittanceDetails.length > 0) {
        const partnerRemittance = props.remittanceDetails.find((b: any) => b.remittance_type_name === REMITTANCE_TYPE['partner']);
        if(partnerRemittance){
          // setBipd(partnerRemittance.bipd)
          setBipd(partnerRemittance.bipd !== undefined && partnerRemittance.bipd !== null && partnerRemittance.bipd !== "" ? partnerRemittance.bipd : null);
        }
      }
      // eslint-disable-next-line
     },[remittanceDetails])

  let agency_actual_remittance  = remittanceDetails.length ? Number(remittanceDetails?.filter((b: any) => b.remittance_type_name === REMITTANCE_TYPE['agency'])?.[0]?.actual_remittance) : 0;     
  if (isNaN(agency_actual_remittance)) {
    agency_actual_remittance = 0;
  }
  const gross_profit = (Number(revenue?.revenue) ?? 0) - (Number(revenue?.discount) ?? 0) - (Number(agency_actual_remittance) ?? 0);

  // const net_collectibles = gross_profit - revenue?.wht - revenue?.vat;  
  const net_collectibles = gross_profit - revenue?.wht + revenue?.vat;  
  return (
    <>
      {/* OTO's Revenue Card */}
      <div className="remittance-card">
        <div className="remittance-header">
          <h2>{translations.Remittance?.["OTO_REVENUE"] || translations.commonMsg?.loading}</h2>
        </div>
        <div className="remittance-table">

          <div className="remittance-row">
            <span>{translations.Remittance?.["COMMISSION_RATE_SCHEME"] || translations.commonMsg?.loading}</span>
            <span className="highlight">{revenue?.commission_rate_scheme || 'NA'}</span>
          </div>

          <div className="remittance-row">
            <span>{translations.Remittance?.["BASE_ISSUE_RATE"] || translations.commonMsg?.loading}</span>
            <span>{revenue?.base_rate || 0}%</span>
          </div>

          <div className="remittance-row">
            <span>
              {
                (bipd !== undefined && bipd !== null)
                  ? (translations.Remittance?.["COMMISSION_NET_RATE_BI_PD"] || translations.commonMsg?.loading)
                  : (translations.Remittance?.["COMMISSION_NET_RATE_NO_BI_PD"] || translations.commonMsg?.loading)
              }
            </span>
             <span>{revenue?.commission_rate_partner || 0} {bipd !== undefined && bipd !== null ? `, ${bipd}%` : ""}</span>
          </div>

          <div className="remittance-row">
            <span>{translations.Remittance?.["COMMISSION_TO_OTO"] || translations.commonMsg?.loading}</span>
            <span>{`${HELPER.addCurrencyFormatting(Number(revenue?.commission_to_oto || 0).toFixed(2))}`}</span>
          </div>

          <div className="remittance-row">
            <span>{translations.Remittance?.["REVENUE"] || translations.commonMsg?.loading}</span>
            <span>{`${HELPER.addCurrencyFormatting(Number(revenue?.revenue || 0).toFixed(2))}`}</span>
          </div>

          <div className="remittance-row">
            <span>{translations.Remittance?.["WITHHOLDING_TAX"] || translations.commonMsg?.loading}</span>
            <span>{`${HELPER.addCurrencyFormatting(Number(revenue?.wht || 0).toFixed(2))}`}</span>
          </div>

          {/* <div className="remittance-row">
            <span>{translations.Remittance?.["NET_REVENUE"] || translations.commonMsg?.loading}</span>
            <span>{`${HELPER.addCurrencyFormatting(Number(revenue?.net_revenue || 0).toFixed(2))}`}</span>
          </div> */}

          <div className="remittance-row">
            <span>{translations.Remittance?.["GROSS_PROFIT"] || translations.commonMsg?.loading}</span>
            <span>{`${HELPER.addCurrencyFormatting(Number(gross_profit || 0).toFixed(2))}`}</span>
          </div>

          <div className="remittance-row">
            <span>{translations.Remittance?.["VAT"] || translations.commonMsg?.loading}</span>
            <span>{`${HELPER.addCurrencyFormatting(Number(revenue?.vat || 0).toFixed(2))}`}</span>
          </div> 
          
          <div className="remittance-row">
            <span>{translations.Remittance?.["NET_COLLECTIBLES"] || translations.commonMsg?.loading}</span>
            <span>{`${HELPER.addCurrencyFormatting(Number(net_collectibles || 0).toFixed(2))}`}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtoRevenueCard;
